module.exports = __webpack_public_path__ + "static/media/13.9c3724fe.gif";